import { render, staticRenderFns } from "./navigator.vue?vue&type=template&id=e3306e76&scoped=true&"
import script from "./navigator.vue?vue&type=script&lang=js&"
export * from "./navigator.vue?vue&type=script&lang=js&"
import style0 from "./navigator.vue?vue&type=style&index=0&id=e3306e76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3306e76",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
